import { SelectOption } from '../models';

export const enum Orientation {
  'DEG0' = 'DEG0',
  'DEG90' = 'DEG90',
  'DEG180' = 'DEG180',
  'DEG270' = 'DEG270',
}

/**
 * Utilities of Orientation Enum
 */
export class OrientationHelper {
  private static readonly orientationLabelMap: Record<Orientation, string> = {
    [Orientation.DEG0]: 'Parallel',
    [Orientation.DEG90]: 'Perpendicular',
    [Orientation.DEG180]: '180',
    [Orientation.DEG270]: '270',
  };

  static enumToLabelKey(orientation: Orientation): string {
    return this.orientationLabelMap[orientation] ?? '';
  }

  private static getConstantList(): Orientation[] {
    return [Orientation.DEG0, Orientation.DEG90];
  }

  static getOptions(): SelectOption[] {
    return this.getConstantList().map((orientation) => ({
      label: this.enumToLabelKey(orientation),
      value: orientation,
    }));
  }
}
